export default "__VITE_ASSET__BoVl18fq__"